<div id="geolocationModalContainer" class="flex justify-content-center geolocation-not-allowed w-100 p-5">
    <app-activate-location [isModal]="true" (closeModalEvent)="closeGeolocationModal()"></app-activate-location>
</div>
